import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 5V13H7.83L10.41 10.41L9 9L4 14L9 19L10.41 17.59L7.83 15H20V5H18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SubLeft"
);
